import { Profile } from '../../components/font-end/Profile/Profile';
import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { ServiceMenu } from '../../components/font-end/Service/ServiceMenu';
import { useUser } from '../../context/UserContext';

export const Service = (props: any) => {
  const { userInfo, isLoading } = useUser();

  if (isLoading) {
    return (
      <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Profile />
      <ServiceMenu profile={userInfo?.codComp1 !== 'PST'} />
      {userInfo?.codComp1 !== 'PST' && <Menubar />}
    </>
  );
};
